export default __webpack_public_path__ + "static/media/programme-examples.f1bafef3.svg";